<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="formLabelCol">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="版本号">
              <global-select
                :value.sync="queryParams.planVersion"
                selectType="selectSearch"
                requestApi="/inv/invWipAllocationPlan/planVersionBox"
                :selectItem="{ value: 'realValue', label: 'label' }"
                :setParams="{ planTypeList: [2, 4] }"
                searchParam="planVersion"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="存放区域">
              <global-select
                :value.sync="queryParams.areaNameList"
                selectType="selectMultiple"
                requestApi="/system/lookup/data/list"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
                :setParams="{ lookupType: 'INV_DEFAULT_AREA' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="物料编码">
              <a-input v-model="queryParams.itemCodeVal" allowClear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="物料名称">
              <a-input v-model="queryParams.itemName" allowClear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="状态">
              <global-select
                :value.sync="queryParams.statusList"
                selectType="selectMultiple"
                requestApi="/system/lookup/data/list"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
                :setParams="{ lookupType: 'INV_ALLOCATION_PLAN_STATUS' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="入库仓">
              <global-select
                :value.sync="queryParams.warehouseCode"
                requestApi="/system/lookup/data/list"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
                :setParams="{ lookupType: '4PL_WAREHOUSE_DESCRIPTION', pageSize: 1000 }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="调拨到仓日期" :labelCol="{ style: { width: '90px' } }">
              <a-tooltip>
                <template slot="title">{{ $timeText(queryParams.deliveryDate, 'YYYY-MM-DD') }}</template>
                <a-range-picker v-model="queryParams.deliveryDate" valueFormat="YYYY-MM-DD" allowClear />
              </a-tooltip>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="创建时间">
              <a-tooltip>
                <template slot="title">{{ $timeText(queryParams.createDate, 'YYYY-MM-DD') }}</template>
                <a-range-picker v-model="queryParams.createDate" valueFormat="YYYY-MM-DD" allowClear />
              </a-tooltip>
            </a-form-item>
          </a-col>
          <a-col :md="12" :sm="24" v-if="advanced">
            <a-form-item label="调拨类型">
              <a-select
                v-model="queryParams.planTypeList"
                allowClear
                show-search
                option-filter-prop="children"
                mode="multiple"
                :maxTagCount="2"
              >
                <a-select-option v-for="item in planTypeList" :key="item.lookupCode">{{ item.lookupValue }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="24" :sm="24" class="aj-center-between">
            <a-form-item label="快捷过滤">
              <a-button v-for="item in searchList1" :key="item.id" type="link" @click="handleMenuClick(item)">{{ item.schemeName }}</a-button>
              <a-dropdown v-if="searchList2.length > 0">
                <a-menu slot="overlay">
                  <a-menu-item v-for="item in searchList2" :key="item.id" @click="handleMenuClick(item)">{{ item.schemeName }}</a-menu-item>
                </a-menu>
                <a-button type="link">更多<a-icon type="down" /> </a-button>
              </a-dropdown>
              <a-button @click="$refs.dressingByScreening.show(queryParams)">保存筛选方案</a-button>
            </a-form-item>
            <span class="table-page-search-submitButtons">
              <a-button @click="$refs.dressingByScreeningSetUp.show()">设置筛选方案</a-button>
              <a-button @click="onSearch()" type="primary" class="ml8">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
              <a @click="toggleAdvanced" class="ml8">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <download-modal :apiFun="apiInvWipAllocationPlanNewExport" ref="download" />
      <a-dropdown v-hasPermi="['inv:invWipAllocationPlan:baseBtn']">
        <a-menu slot="overlay" @click="(keyVal)=>handleAddOrCal(keyVal, 'base')">
          <a-menu-item key="add">新增</a-menu-item>
          <a-menu-item key="cal">执行运算</a-menu-item>
        </a-menu>
        <a-button :loading="executeOperationsLoading" type="primary"> 基地仓 <a-icon type="down" /> </a-button>
      </a-dropdown>
      <a-dropdown v-hasPermi="['inv:invWipAllocationPlan:satelliteBtn']">
        <a-menu slot="overlay" @click="(keyVal)=>handleAddOrCal(keyVal, 'satellite')">
          <a-menu-item key="add">新增</a-menu-item>
          <a-menu-item key="cal">执行运算</a-menu-item>
        </a-menu>
        <a-button :loading="executeOperationsLoading" type="primary"> 卫星仓 <a-icon type="down" /> </a-button>
      </a-dropdown>
<!--      <a-button @click="$refs.allocationPlanAdd.show()" type="primary" v-hasPermi="['inv:invWipAllocationPlan:dispatchAddUpdate']">新增</a-button>-->
      <a-button :disabled="selectedRows.length === 0" :loading="publishLoading" @click="publish" type="primary" v-hasPermi="['inv:invWipAllocationPlan:dispatchRelease']">发布</a-button>
<!--      <a-button @click="executeOperations" :loading="executeOperationsLoading" type="primary" v-hasPermi="['inv:invWipAllocationPlan:dispatchOperations']">执行运算</a-button>-->
      <a-button :disabled="selectedRows.length === 0" @click="batchUpdateWarehouse" type="primary" v-hasPermi="['inv:invWipAllocationPlan:compartmentBatchUpdateWh']">批量更新目的仓</a-button>
      <a-button @click="handleExport" type="primary" v-hasPermi="['inv:invOrderSatisfyRate:dispatchExport']">导出</a-button>
      <a-button :disabled="selectedRows.length === 0" :loading="choooseCancelLoading" @click="choooseCancel" type="primary" v-hasPermi="['inv:invWipAllocationPlan:dispatchCancel']">作废</a-button>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          :multi-select="true"
          rowKey="serialNumber"
          :scroll="{ fixScreen: true, x: 4600 }"
          @successCallBack="successCallBack"
          @change="handleTableChange"
          :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.ALLOCATION_PLAN_LIST, // 表格方案配置唯一值
              }"
        >
          <span slot="checkboxTitle">
            <a-checkbox :checked="allChecked" @change="allCheckedChange"></a-checkbox>
          </span>
          <span v-for="item in titleList" :key="item.key" :slot="`${item.key}Title`" class="align-center">
            <i v-if="item.isMust" class="toRequired">*</i>{{ item.title }}&nbsp;
            <a-popover>
              <template slot="content">
                <p>{{ item.prompt }}</p>
              </template>
              <span><a-icon type="info-circle" /></span>
            </a-popover>
          </span>
          <template #deliveryDateTitle>
            <span>调拨到仓日期</span>
            <a-icon class="action-icon" @click.stop="onEditDate" type="edit" title="编辑"/>
          </template>
          <template v-for="item in columns" :slot="item.dataIndex" slot-scope="{ text, record, index }">
            <div :key="item.dataIndex">
              <span v-if="item.dataIndex === 'operation'">
                <a v-if="!isEdit || currentId !== record.id" :disabled="record.status !== '0'" @click="handleEdit(record)" v-hasPermi="['inv:invWipAllocationPlan:dispatchUpdate']">编辑</a>
                <a v-if="isEdit && currentId === record.id" @click="handleSave(record)">保存</a>
                <a v-if="isEdit && currentId === record.id" @click="handleCancel(record)" class="ml10">取消</a>
              </span>
              <span v-else-if="item.dataIndex === 'checkbox'">
                <a-checkbox :checked="record[item.dataIndex]" @change="(e) => { checkedChange(e, index) }"></a-checkbox>
              </span>
              <span v-else-if="item.type === 'date'">
                <span v-if="!isEdit || currentId !== record.id">{{ record[item.dataIndex] }}</span>
                <a-date-picker v-if="isEdit && currentId === record.id" v-model="record[item.dataIndex]" size="small" valueFormat="YYYY-MM-DD"/>
              </span>
              <span v-else-if="item.type === 'inputNumber'">
                <span v-if="!isEdit || currentId !== record.id">{{ record[item.dataIndex] }}</span>
                <a-input-number v-if="isEdit && currentId === record.id" v-model="record[item.dataIndex]" :min="0" size="small" />
              </span>
              <span v-else-if="item.type === 'text'">{{ text && $moment(text).format('YYYY-MM-DD HH:mm:ss') }}</span>
              <span v-else>{{ text }}</span>
            </div>
          </template>
        </ls-api-table>
        <allocation-plan-add ref="allocationPlanAdd" @handle-success="handleOk" />
      </div>
      <dressing-by-screening-set-up ref="dressingByScreeningSetUp" @handle-success="handleOk2" />
      <dressing-by-screening ref="dressingByScreening" @handle-success="handleOk2" />
      <batch-edit-delivery-date-modal ref="batchEditDeliveryDateModal" @click="handleOk"/>
      <batch-update-warehouse-modal ref="batchUpdateWarehouseModal" @handle-success="onSearch"/>
    </template>
  </ls-table-layout>
</template>

<script>
import { mapState } from 'vuex'
import {
  apiInvWipAllocationPlanDispatchUpdate,
  apiInvWipAllocationPlanCompartmentList,
  apiInvWipAllocationPlanDispatchRelease,
  apiInvWipAllocationPlanDispatchOperations,
  apiInvWipAllocationPlanNewExport,
  apiInvWipAllocationPlanDispatchCancel,
  apiInvWipAllocationPlanDdispatchOperationsForWxc
} from '@/api/mes/scheduling-plan/allocation-plan'
import AllocationPlanAdd from './components/allocation-plan-add'
import { generateLsTableResData, handleCopyFromExcel } from '@/utils/util.js'
import DressingByScreening from '@/components/DressingByScreening/index'
import DressingByScreeningSetUp from '@/components/DressingByScreeningSetUp/index'
import { apiScpScreeningSchemeSearchAllScheme } from '@/api/mes/workOrderManage/workOrderDesk'
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
import BatchEditDeliveryDateModal from '@/views/mes/scheduling-plan/allocation-plan/components/batch-edit-delivery-date-modal'
import BatchUpdateWarehouseModal from '@/views/mes/scheduling-plan/sub-warehouse-plan/components/batch-update-warehouse-modal.vue'
import moment from 'moment'

export default {
  // eslint-disable-next-line
  name: 'Allocation-plan', // name要和rms配置菜单路由保存一致(首字母大写)
  components: {
    DownloadModal,
    AllocationPlanAdd,
    DressingByScreening,
    DressingByScreeningSetUp,
    BatchEditDeliveryDateModal,
    BatchUpdateWarehouseModal
  },
  data () {
    return {
      planTypeList: [], // 调拨类型
      apiInvWipAllocationPlanNewExport,
      searchList1: [],
      searchList2: [],
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiInvWipAllocationPlanCompartmentList, true),
        pageCurrent: true
      },
      isEdit: false,
      currentId: "",
      // 控制搜索展开
      advanced: true,
      formLabelCol: { style: { width: '80px' } },
      // 查询参数
      queryParams: {
        planTypeList: ['2', '4'],
        planVersion: undefined,
        areaNameList: undefined,
        itemCodeVal: undefined,
        itemName: undefined,
        statusList: undefined,
        deliveryDate: [],
        createDate: []
      },
      // 表格数据
      tableList: [],
      // 表格多选
      selectedRowKeys: [],
      selectedRows: [],
      allChecked: false,
      // 表格字段
      columns: [
        {
          // title: '复选框',
          customTitle: '复选框',
          dataIndex: 'checkbox',
          scopedSlots: { customRender: 'checkbox', title: "checkboxTitle" },
          width: 50,
          stickyFixed: 'left'
        },
        {
          title: '版本号',
          stickyFixed: 'left',
          width: 200,
          ellipsis: true,
          dataIndex: 'planVersion',
          align: 'center'
        },
        {
          title: '物料编码',
          dataIndex: 'itemCode',
          align: 'center',
          ellipsis: true,
          width: 150,
          stickyFixed: 'left'
        },
        {
          title: '存放区域',
          dataIndex: 'areaName',
          align: 'center',
          ellipsis: true,
          width: 150,
          stickyFixed: 'left'
        },
        {
          // title: '调拨到仓日期',
          customTitle: '调拨到仓日期',
          dataIndex: 'deliveryDate',
          scopedSlots: { customRender: 'deliveryDate', title: "deliveryDateTitle" },
          align: 'center',
          width: 160,
          type: "date",
          sorter: true
        },
        {
          // title: '可调拨数量',
          customTitle: '可调拨数量',
          dataIndex: 'allocableQty',
          scopedSlots: { title: "allocableQtyTitle" },
          align: 'center',
          sorter: true
        },
        {
          // title: '本次调拨数量',
          customTitle: '本次调拨数量',
          dataIndex: 'assignedQty',
          scopedSlots: { customRender: 'assignedQty', title: "assignedQtyTitle" },
          align: 'center',
          width: 170,
          type: "inputNumber",
          sorter: true
        },
        {
          title: '4PL分配数量',
          dataIndex: 'fplAssignedQty',
          align: 'center'
        },
        {
          title: '装车数量',
          dataIndex: 'onwayQty',
          align: 'center',
          sorter: true
        },
        {
          title: '入库数量',
          dataIndex: 'receiptQty',
          align: 'center',
          sorter: true
        },
        {
          title: '取消数量',
          dataIndex: 'cancelQty',
          align: 'center'
        },
        {
          // title: '已分配卡板数',
          customTitle: '已分配卡板数',
          dataIndex: 'assignedPalletQty',
          scopedSlots: { title: "assignedPalletQtyTitle" },
          align: 'center'
        },
        {
          title: 'ODS调拨单号',
          dataIndex: 'odsTransferNo',
          align: 'center'
        },
        {
          title: '状态',
          dataIndex: 'statusName',
          align: 'center'
        },
        {
          title: '物料名称',
          dataIndex: 'itemName',
          align: 'center',
          ellipsis: true
        },
        {
          title: '规格描述',
          dataIndex: 'specification',
          align: 'center',
          ellipsis: true
        },
        {
          // title: '安全库存水位',
          customTitle: '安全库存水位',
          dataIndex: 'safetyStockLevel',
          scopedSlots: { title: "safetyStockLevelTitle" },
          align: 'center',
          ellipsis: true
        },
        {
          // title: '客审未货审订单',
          customTitle: '客审未货审订单',
          dataIndex: 'orderQty',
          scopedSlots: { title: "orderQtyTitle" },
          align: 'center',
          ellipsis: true,
          sorter: true
        },
        {
          // title: '当前订单满足率',
          customTitle: '当前订单满足率',
          dataIndex: 'currentSatisfyRate',
          scopedSlots: { title: "currentSatisfyRateTitle" },
          align: 'center',
          ellipsis: true,
          sorter: true
        },
        {
          // title: '当前可用数',
          customTitle: '当前可用数',
          dataIndex: 'currentAvailableQty',
          scopedSlots: { title: "currentAvailableQtyTitle" },
          align: 'center',
          sorter: true
        },
        {
          // title: '当天欠货数',
          customTitle: '当天欠货数',
          dataIndex: 'currentQhQty',
          scopedSlots: { title: "currentQhQtyTitle" },
          align: 'center'
        },
        {
          // title: '5天欠货数',
          dataIndex: 'backlog5',
          scopedSlots: { title: "backlog5Title" },
          align: 'center'
        },
        {
          // title: '10天欠货数',
          dataIndex: 'backlog10',
          scopedSlots: { title: "backlog10Title" },
          align: 'center'
        },
        {
          // title: '15天欠货数',
          dataIndex: 'backlog15',
          scopedSlots: { title: "backlog15Title" },
          align: 'center'
        },
        {
          // title: '20天欠货数',
          dataIndex: 'backlog20',
          scopedSlots: { title: "backlog20Title" },
          align: 'center'
        },
        {
          // title: '25天欠货数',
          dataIndex: 'backlog25',
          scopedSlots: { title: "backlog25Title" },
          align: 'center'
        },
        {
          // title: '30天欠货数',
          dataIndex: 'backlog30',
          scopedSlots: { title: "backlog30Title" },
          align: 'center'
        },
        {
          title: '来源仓库',
          dataIndex: 'sourceSarehouseName',
          align: 'center',
          ellipsis: true
        },
        {
          title: '目的仓库',
          dataIndex: 'desWarehouseName',
          align: 'center',
          ellipsis: true
        },
        {
          title: '基地仓(理货)',
          dataIndex: 'desWarehouseJdcLh',
          align: 'center',
          ellipsis: true
        },
        {
          title: '卫星仓(理货)',
          dataIndex: 'desWarehouseWxcLh',
          align: 'center',
          ellipsis: true
        },
        {
          // title: '调拨后订单满足率',
          customTitle: '调拨后订单满足率',
          dataIndex: 'assignedSatisfyRate',
          scopedSlots: { title: "assignedSatisfyRateTitle" },
          align: 'center',
          width: 190,
          sorter: true
        },
        {
          title: '中心仓剩余库容',
          dataIndex: 'residualCapacity',
          align: 'center'
        },
        {
          // title: '托盘标准容量',
          customTitle: '托盘标准容量',
          dataIndex: 'palletStandardQty',
          scopedSlots: { title: "palletStandardQtyTitle" },
          align: 'center'
        },
        // {
        //   title: '作业能力',
        //   dataIndex: 'workAbility',
        //   align: 'center'
        // },
        {
          title: '创建人',
          dataIndex: 'createName',
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          width: 160,
          align: 'center',
          type: "text"
        },
        {
          title: '更新人',
          dataIndex: 'updateName',
          align: 'center'
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime',
          scopedSlots: { customRender: 'updateTime' },
          width: 160,
          align: 'center',
          type: "text"
        },
        {
          title: '取消失败原因',
          dataIndex: 'cancelFailReason',
          align: 'center'
        },
        {
          title: '操作',
          width: 100,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          stickyFixed: 'right'
        }
      ],
      sorterParams: {},
      timer: null,
      titleList: [
        {
          key: "safetyStockLevel",
          isMust: false,
          title: "安全库存水位",
          prompt: "取订单满足率标准维护界面中 维护的安全库存水位"
        },
        {
          key: "orderQty",
          isMust: false,
          title: "客审未货审订单",
          prompt: "取每天BI报表的数据，若当日BI报表生成有问题则延用前一天获取的数据"
        },
        {
          key: "currentSatisfyRate",
          isMust: false,
          title: "当前订单满足率",
          prompt: "当前可用数/客审未货审订单"
        },
        {
          key: "currentAvailableQty",
          isMust: false,
          title: "当前可用数",
          prompt: "中心仓可用量+基地仓到中心仓在途+已分中心仓未完工数+产业园供应商库存数+外部供应商到中心仓在途+基地仓可用数"
        },
        {
          key: "currentQhQty",
          isMust: false,
          title: "当天欠货数",
          prompt: "取每天BI报表的数据，若当日BI报表生成有问题则延用前一天获取的数据"
        },
        {
          key: "backlog5",
          isMust: false,
          title: "5天欠货数",
          prompt: "取每天BI报表的数据，若当日BI报表生成有问题则延用前一天获取的数据"
        },
        {
          key: "backlog10",
          isMust: false,
          title: "10天欠货数",
          prompt: "取每天BI报表的数据，若当日BI报表生成有问题则延用前一天获取的数据"
        },
        {
          key: "backlog15",
          isMust: false,
          title: "15天欠货数",
          prompt: "取每天BI报表的数据，若当日BI报表生成有问题则延用前一天获取的数据"
        },
        {
          key: "backlog20",
          isMust: false,
          title: "20天欠货数",
          prompt: "取每天BI报表的数据，若当日BI报表生成有问题则延用前一天获取的数据"
        },
        {
          key: "backlog25",
          isMust: false,
          title: "25天欠货数",
          prompt: "取每天BI报表的数据，若当日BI报表生成有问题则延用前一天获取的数据"
        },
        {
          key: "backlog30",
          isMust: false,
          title: "30天欠货数",
          prompt: "取每天BI报表的数据，若当日BI报表生成有问题则延用前一天获取的数据"
        },
        {
          key: "allocableQty",
          isMust: false,
          title: "可调拨数量",
          prompt: "取基地仓当前可用量=（佛山仓+卫星仓+青岛仓）库存可用数+基地仓调拨佛山仓/卫星仓在途+已分仓佛山仓/卫星仓未入库在途+外部供应商到中心仓在途数"
        },
        {
          key: "assignedQty",
          isMust: true,
          title: "本次调拨数量",
          prompt: "（客审未货审订单*标准订单满足率）-中心仓当前可用数 ）与 可调拨数量 取小 ）在与 （安全库存水位-中心仓可用数） 取大 最后 在跟 可调拨数量取小"
        },
        {
          key: "assignedSatisfyRate",
          isMust: false,
          title: "调拨后订单满足率",
          prompt: "当前可用数+本次调拨数量）/客审未货审订单"
        },
        {
          key: "assignedPalletQty",
          isMust: false,
          title: "已分配卡板数",
          prompt: "分仓数量/托套比，向上取整"
        },
        {
          key: "palletStandardQty",
          isMust: false,
          title: "托盘标准容量",
          prompt: "每托上放多少套产品"
        }
      ],
      publishLoading: false,
      executeOperationsLoading: false,
      choooseCancelLoading: false
    }
  },
  computed: {
    ...mapState({
      organizationCodeOrigin: (state) => state.user.organizationCode
    })
  },
  created () {},
  mounted () {
    // 其他页面跳转进来，如果带了planType，就作为查询条件
    this.queryParams.planTypeList = this.$route?.query?.planType ? [this.$route.query.planType] : ['2', '4']
    if (this.$route.query && Object.keys(this.$route.query).length > 0) {
      this.searchByRoute()
    }
    this.onSearch()
    this.getCategoryIdList(true)
    this.getPlanTypeList()
  },
  activated() {
    // 其他页面跳转进来，如果带了planType，就作为查询条件
    this.queryParams.planTypeList = this.$route?.query?.planType ? [this.$route.query.planType] : ['2', '4']
    if (this.$route.query && Object.keys(this.$route.query).length > 0) {
      this.searchByRoute()
    }
    this.onSearch()
  },
  methods: {
    // 调拨类型下拉查询
    getPlanTypeList () {
      const lookupQueryParams = {
        lookupType: 'INV_ALLOCATION_PLAN_TYPE',
        current: 1,
        pageSize: 999
      }
      this.getLookupListData(lookupQueryParams).then().then(res => {
        this.planTypeList = res?.rows || []
        this.planTypeList = this.planTypeList.filter(item => ['2', '4'].includes(item.lookupCode))
      })
    },
    // 基地仓和卫星仓组合按钮
    handleAddOrCal(val, type) {
      if(val?.key === 'add') {
        this.$refs.allocationPlanAdd.show(type)
      }else if(val?.key === 'cal') {
        this.executeOperations(type)
      }else {
        this.$message.warning('请检查按钮key值')
      }
    },
    searchByRoute () {
      const { areaNameList, deliveryDate, warehouseCode, materialNo } = this.$route.query
      this.queryParams.areaNameList = areaNameList ? [areaNameList] : undefined
      this.queryParams.deliveryDate = [deliveryDate, deliveryDate]
      this.queryParams.warehouseCode = warehouseCode
      this.queryParams.itemCodeVal = materialNo
    },
    handleOk2 () {
      this.getCategoryIdList()
    },
    // 批量更新目的仓
    batchUpdateWarehouse () {
      if (this.selectedRows.length === 0) {
        this.$message.warning('请选择需要修改的数据')
        return
      }
      const hasNotUnrelease = this.selectedRows.some(item => item.status !== '0')
      if (hasNotUnrelease) {
        this.$message.warning('只允许修改未发布状态的数据')
        return
      }
      this.$refs.batchUpdateWarehouseModal.show(this.selectedRows)
    },
    // 快捷过滤数据
    getCategoryIdList (flag) {
      apiScpScreeningSchemeSearchAllScheme({ menuId: this.$route.meta.menuId }).then(res => {
        if (res.data && res.data.length > 0) {
          const arr = []
          const arr2 = []

          res.data.forEach((element, index) => {
            if (index < 3) {
              arr.push(element)
            } else {
              arr2.push(element)
            }
            if (flag && element.defaultFlag === "Y") {
              this.queryParams = JSON.parse(element.schemeDetailJson)
              this.onSearch()
            }
          });
          this.searchList1 = arr
          this.searchList2 = arr2
        } else {
          this.searchList1 = []
          this.searchList2 = []
        }
      })
    },
    // 作废
    choooseCancel () {
      let flag = false
      for (let i = 0; i < this.selectedRows.length; i++) {
        if (this.selectedRows[i].statusName !== "未发布" && this.selectedRows[i].statusName !== "已发布") {
          this.$message.warning('只允许对未发布和已发布状态的数据进行操作')
          flag = true
          return
        }
      }
      if (flag) {
        return false
      }
      this.choooseCancelLoading = true
      apiInvWipAllocationPlanDispatchCancel(this.selectedRowKeys).then(response => {
        if (response.code === 200) {
          this.$message.success('作废成功!')
          this.onSearch()
        } else {
          this.$message.error(response.msg)
        }
        this.choooseCancelLoading = false
      }).catch(e => {
        this.choooseCancelLoading = false
      })
    },
    // 发布
    publish () {
      this.publishLoading = true
      apiInvWipAllocationPlanDispatchRelease(this.selectedRows).then(response => {
        if (response.code === 200) {
          if (response.data === false && response?.msg) {
            this.$warning({
              title: '提示',
              content: response.msg,
              okText: '确定'
            });
            this.publishLoading = false
            return false
          }
          this.$message.success('发布成功!')
          this.onSearch()
        } else {
          this.$message.error(response.msg)
        }
        this.publishLoading = false
      }).catch(e => {
        this.publishLoading = false
      })
    },
    // 执行运算
    executeOperations (type) {
      this.executeOperationsLoading = true
      const apiVal = type === 'satellite' ? apiInvWipAllocationPlanDdispatchOperationsForWxc : apiInvWipAllocationPlanDispatchOperations
      apiVal().then(response => {
        if (response.code === 200) {
          this.$message.success('执行运算成功!')
          this.onSearch()
        } else {
          this.$message.error(response.msg)
        }
        this.executeOperationsLoading = false
      }).catch(e => {
        this.executeOperationsLoading = false
      })
    },
    // 表单搜索
    onSearch (isNotGoFirstPage) {
      const obj = JSON.parse(JSON.stringify(this.queryParams))
      handleCopyFromExcel('itemCode', 'itemCodes', obj) // 物料编码支持excel的copy查询
      // 交货日期
      obj.staDeliveryDate = obj.deliveryDate.length > 0 ? (obj.deliveryDate[0] + " 00:00:00") : ""
      obj.endDeliveryDate = obj.deliveryDate.length > 0 ? (obj.deliveryDate[1] + " 23:59:59") : ""
      delete obj.deliveryDate
      // 创建时间
      obj.startCreateDate = obj.createDate.length > 0 ? (obj.createDate[0] + " 00:00:00") : ""
      obj.endCreateDate = obj.createDate.length > 0 ? (obj.createDate[1] + " 23:59:59") : ""
      delete obj.createDate
      this.isEdit = false;
      if(!(obj?.planTypeList) || obj?.planTypeList?.length < 1) {
        obj.planTypeList = ['2', '4'] // 默认要查2和4
      }
      this.$refs.dataTable.searchParams = { ...obj, ...this.sorterParams };
      this.$refs.dataTable.getData(isNotGoFirstPage);
    },
    handleTableChange (pagination, filters, sorter, { currentDataSource }) {
      debugger
      const obj = {}
      if (sorter.columnKey === "orderQty") {
        obj.pxOrderQty = sorter.order === "ascend" ? 0 : 1
      }
      if (sorter.columnKey === "currentSatisfyRate") {
        obj.pxCurrentSatisfyRate = sorter.order === "ascend" ? 0 : 1
      }
      if (sorter.columnKey === "currentAvailableQty") {
        obj.pxCurrentAvailableQty = sorter.order === "ascend" ? 0 : 1
      }
      if (sorter.columnKey === "allocableQty") {
        obj.pxAllocableQty = sorter.order === "ascend" ? 0 : 1
      }
      if (sorter.columnKey === "assignedSatisfyRate") {
        obj.pxAssignedSatisfyRate = sorter.order === "ascend" ? 0 : 1
      }
      // 本次调拨数量
      if (sorter.columnKey === "assignedQty") {
        obj.pxAssignedQty = sorter.order === "ascend" ? 0 : 1
      }
      // 入库数量
      if (sorter.columnKey === "receiptQty") {
        obj.pxReceiptQty = sorter.order === "ascend" ? 0 : 1
      }
      // 调拨到仓日期
      if (sorter.columnKey === "deliveryDate") {
        obj.pxDeliveryDate = sorter.order === "ascend" ? 0 : 1
      }
      // 装车数量
      if (sorter.columnKey === "onwayQty") {
        obj.pxOnwayQty = sorter.order === "ascend" ? 0 : 1
      }
      this.sorterParams = obj

      // 交货日期
      const items = JSON.parse(JSON.stringify(this.queryParams))
      // 交货日期
      items.staDeliveryDate = items.deliveryDate.length > 0 ? (items.deliveryDate[0] + " 00:00:00") : ""
      items.endDeliveryDate = items.deliveryDate.length > 0 ? (items.deliveryDate[1] + " 23:59:59") : ""
      delete items.deliveryDate
      // 创建时间
      obj.startCreateDate = obj.createDate.length > 0 ? (obj.createDate[0] + " 00:00:00") : ""
      obj.endCreateDate = obj.createDate.length > 0 ? (obj.createDate[1] + " 23:59:59") : ""
      delete obj.createDate
      this.isEdit = false
      this.$refs.dataTable.searchParams = { ...items, ...this.sorterParams }
    },
    // 接口请求成功后回调
    successCallBack (myDataSource) {
      const tableList = JSON.parse(JSON.stringify(myDataSource))
      for (let i = 0; i < tableList.length; i++) {
        tableList[i].checkbox = false
      }
      this.$refs.dataTable.myDataSource = tableList
      this.tableList = tableList
      this.allChecked = false
      this.selectedRowKeys = []
      this.selectedRows = []
    },
    // 全选
    allCheckedChange (e) {
      this.allChecked = e.target.checked;
      const tableList = JSON.parse(JSON.stringify(this.tableList))
      const arr = []
      const arr2 = []
      tableList.forEach(element => {
        element.checkbox = this.allChecked ? this.allChecked : false
        arr.push(element.id)
        arr2.push(element)
      });
      this.selectedRowKeys = this.allChecked ? arr : []
      this.selectedRows = this.allChecked ? arr2 : []
      this.$refs.dataTable.myDataSource = tableList
      this.tableList = tableList
    },
    // 复选框-行
    checkedChange (e, index) {
      const tableList = JSON.parse(JSON.stringify(this.tableList))
      tableList.forEach(element => {
        if (element.id === tableList[index].id) {
          element.checkbox = e.target.checked
        }
      });

      const arr = []
      const arr2 = []
      tableList.forEach(element => {
        if (element.checkbox) {
          arr.push(element.id)
          arr2.push(element)
        }
      });
      this.selectedRowKeys = arr
      this.selectedRows = arr2
      this.$refs.dataTable.myDataSource = tableList
      this.tableList = tableList
    },
    // 编辑
    handleEdit (record) {
      if (this.currentId && record.id !== this.currentId && this.isEdit) {
        this.$message.warning('请保存上次编辑的数据')
        return;
      }
      this.isEdit = true;
      this.currentId = record.id;
    },
    // 编辑-保存
    handleSave (record) {
      const tableList = JSON.parse(JSON.stringify(this.$refs.dataTable.myDataSource))
      const params = []
      let flag = false
      for (let i = 0; i < tableList.length; i++) {
        if (tableList[i].id === record.id) {
          if (!tableList[i].assignedQty && tableList[i].assignedQty !== 0) {
            this.$message.warning('本次调拨数量不能为空')
            flag = true
            return
          }
          tableList[i].headerId = tableList[i].id
          params.push(tableList[i])
        }
      }
      if (flag) {
        return false
      }
      apiInvWipAllocationPlanDispatchUpdate(params).then(response => {
        if (response.code === 200) {
          this.$message.success('保存成功')
          this.isEdit = false
          this.onSearch()
        } else {
          this.$message.error(response.msg)
        }
      })
    },
    // 取消
    handleCancel (record) {
      this.isEdit = false
      this.onSearch()
    },
    // 新增/修改框事件
    handleOk () {
      this.onSearch()
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.onSearch()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.sorterParams = {}
      this.queryParams = {
        planTypeList: [],
        planVersion: undefined,
        areaNameList: undefined,
        itemCodeVal: undefined,
        itemName: undefined,
        statusList: undefined,
        deliveryDate: [],
        createDate: []
      }
      this.handleQuery()
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 导出按钮操作 */
    handleExport () {
      const obj = JSON.parse(JSON.stringify(this.queryParams))
      handleCopyFromExcel('itemCode', 'itemCodes', obj) // 物料编码支持excel的copy查询
      // 交货日期
      obj.staDeliveryDate = obj.deliveryDate.length > 0 ? moment(obj.deliveryDate[0]).format('YYYY-MM-DD 00:00:00') : ""
      obj.endDeliveryDate = obj.deliveryDate.length > 0 ? moment(obj.deliveryDate[1]).format('YYYY-MM-DD 23:59:59') : ""
      delete obj.deliveryDate
      // 创建时间
      obj.startCreateDate = obj.createDate.length > 0 ? (obj.createDate[0] + " 00:00:00") : ""
      obj.endCreateDate = obj.createDate.length > 0 ? (obj.createDate[1] + " 23:59:59") : ""
      delete obj.createDate
      this.isEdit = false;
      this.$refs.download.openModal(obj)
      // this.download('inv/invWipAllocationPlan/dispatchExport', {
      //   ...this.queryParams
      // }, `调拨计划_${new Date().getTime()}.xlsx`)
    },
    // 快捷过滤
    handleMenuClick (val) {
      this.queryParams = JSON.parse(val.schemeDetailJson)
      this.onSearch()
    },
    // 批量更新调拨到仓日期
    onEditDate() {
      if(this.selectedRows.length === 0) {
        return this.$message.warning("请勾选单据进行修改")
      }
      let flag = false
      for (const item of this.selectedRows) {
        if(item.status !== '0') {
          flag = true
          break
        }
      }
      if(flag) {
        return this.$message.warning("请选择状态为未发布的单据")
      }
      this.$refs.batchEditDeliveryDateModal.show(this.selectedRows)
    }
  }
}
</script>

<style scoped lang="less">
/deep/.ant-input-number{
  width: 150px;
}
.action-icon{
  cursor: pointer;
  font-size: 14px;
  color: #0486fe;
}
</style>
